import { useAemConfig } from '@as-react/common-components';
import { showPriceDiscount } from '@as-react/common-utils';
import { useSelector } from 'react-redux';
import { useProductDetailContext } from '../../../containers/product/ProductDetailV2Container';
import { makeGetDynamicSavingsInformation, makeGetNewProduct, makeGetPreviewInformation, makeGetPriceInformation, makeGetProductDefaults, makeGetProductImageAlt, makeGetProductOurPlanet, } from '../../../redux/product/selectors/ProductSelector';
import { getImageSourceSetByProductCode } from '../../../util/ImageUtil';
export const populateMediaCollection = (images, productCode, productImages, videos) => {
    let imageCollection = [];
    let videoCollection = [];
    let mediaCollection = [];
    if (images) {
        imageCollection = images.map((image) => ({
            image,
            sourceSet: getImageSourceSetByProductCode(productCode, image.picture, productImages),
            video: null,
            isVideo: false,
        }));
        mediaCollection = [...imageCollection];
    }
    if (videos && imageCollection.length > 0) {
        videoCollection = videos
            .filter(video => { var _a; return (_a = video.productVideoDetail) === null || _a === void 0 ? void 0 : _a.url; })
            .map(video => ({
            image: imageCollection[0].image,
            sourceSet: imageCollection[0].sourceSet,
            video,
            isVideo: true,
        }));
        mediaCollection.splice(2, 0, ...videoCollection);
    }
    return mediaCollection;
};
export const useProductMedia = () => {
    const { productImageConfig, feature_toggles: { product_gender_icon: showGenderIcon, product_online_exclusive, product_new_label }, } = useAemConfig();
    const { productCode } = useSelector(makeGetProductDefaults());
    const alt = useSelector(makeGetProductImageAlt());
    const dynamicSavingsInformation = useSelector(makeGetDynamicSavingsInformation());
    const showSustainabilityLabel = useSelector(makeGetProductOurPlanet());
    const newProduct = useSelector(makeGetNewProduct());
    const { genderFeatureId } = useSelector(makeGetProductDefaults());
    const { images, priceOverlay, webOnly } = useSelector(makeGetPreviewInformation());
    const { productVideos: videos } = useProductDetailContext();
    const priceInformation = useSelector(makeGetPriceInformation());
    const savingsPercentage = showPriceDiscount(priceInformation.prices, true)
        ? dynamicSavingsInformation === null || dynamicSavingsInformation === void 0 ? void 0 : dynamicSavingsInformation.productDiscountPercentage
        : undefined;
    const showOnlineExclusiveLabel = product_online_exclusive && webOnly;
    const showNewProductLabel = product_new_label && newProduct;
    const mediaCollection = populateMediaCollection(images, productCode, productImageConfig, videos || []);
    return {
        mediaCollection,
        alt,
        labelsConfig: {
            showGenderIcon,
            genderFeatureId,
            savingsPercentage,
            priceOverlay,
            showNewProductLabel,
            showOnlineExclusiveLabel,
            showSustainabilityLabel,
        },
    };
};
